import type { AssetRiskFieldOptionItem } from "./asset-risk-field.type";

import { useAssetRisksReferential } from "@/modules/asset/asset-risk";

export const useAssetRiskField = () => {
  const { riskLevels } = useAssetRisksReferential();

  const options = riskLevels.map(
    (riskLevel): AssetRiskFieldOptionItem => ({
      label: riskLevel.name,
      value: riskLevel.value,
      color: riskLevel.color,
    })
  );

  return {
    options,
  };
};
